<script setup lang="ts">
import type { NavigationMenuTriggerProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { NavigationMenuTrigger, useForwardProps } from 'reka-ui';
import { computed } from 'vue';

import { navigationMenuTriggerStyle } from '.';

const props = defineProps<
	NavigationMenuTriggerProps & {
		class?: HTMLAttributes['class'];
	}
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<NavigationMenuTrigger
		v-bind="forwardedProps"
		:class="cn(navigationMenuTriggerStyle(), 'group', props.class)"
	>
		<slot />
		<IconMaterialSymbolsLightChevronRight
			class="relative top-px ml-1 size-5 text-beige transition duration-300 group-data-[state=closed]:rotate-90 group-data-[state=open]:-rotate-90"
			aria-hidden="true"
		/>
	</NavigationMenuTrigger>
</template>
